import React from 'react';

interface AdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container px-4 py-8 mx-auto">
        <div className="mb-8">
          <h1 className="mb-2 text-3xl font-bold text-gray-800">Panel de administración</h1>
          <p className="text-gray-600">Gestiona equipos, reservas y usuarios</p>
        </div>
        {children}
      </div>
    </div>
  );
};
